import React, { useState, useEffect, useCallback } from "react"
import { Button, Table, InputGroupText, Input, } from "reactstrap"
import Select from "react-select"
import { commonService, raiseClaimService } from "../services"
import Loading from "../components/common/Loading"
import { generateCurrentFY, generateFYList, getLoggedInUser, isTwoObjectsEqual, searchOnEnter } from "../helpers/common"
import RaiseClaimModal from "../components/RaiseClaim/RaiseClaimModal"
import Pagination from '../components/common/PaginatedItems';
import { useLocation, useNavigate } from "react-router-dom";
import { FaInfoCircle } from "react-icons/fa"
import Export from "../components/common/Export"

const RaiseClaimList = ({ index, claim, handleCorporateNoClick }) => {
    const getClaimPipeColor = (status) => {
        if (status === "Withdrawn") return "rgb(255, 102, 102)";
        if (status === "Settled") return "rgb(133,243,120)";
        if (status === "Partially Settled") return "rgb(243,143,56)";
        return "";
    };
    const getCurrentPipeColor = (status) => {
        if (status === "Claim Settled") return "rgb(133,243,120)";
        if (status === "Settlement Pending") return "rgb(243,143,56)";
        return "";
    };
    const getClaimStatusColor = (status) => {
        if (status === "Withdrawn") return { backgroundColor: "rgb(255, 102, 102)" };
        if (status === "Settled") return { backgroundColor: "rgb(133,243,120)" };
        if (status === "Partially Settled") return { backgroundColor: "rgb(243,143,56)" };
        return { backgroundColor: "rgb(211, 211, 212)" };
    };
    const getCurrentStatusColor = (status) => {
        if (status === "Claim withdrawn by Division" || status === "Claim Rejected by Insurer") return { backgroundColor: "rgb(255, 102, 102)" };
        if (status === "Claim Settled") return { backgroundColor: "rgb(133,243,120)" };
        if (status === "Settlement Pending") return { backgroundColor: "rgb(243,143,56)" };
        return { backgroundColor: "rgb(211, 211, 212)" };
    };
    const pipeColor = getClaimPipeColor(claim.claimStatus) || getCurrentPipeColor(claim.currentStatus) || "rgb(107,103,103)";
    return (
        <>
            <td style={{ backgroundColor: pipeColor, padding: "4px" }}></td>
            <td className="text-center sl-n bg-transparent">{index}</td>
            <td className="tbl-w-3 bg-transparent">
                {
                    !claim?.isDraft ? <a href="#" onClick={(e) => {
                        e.preventDefault()
                        handleCorporateNoClick(claim?.raiseClaimId)
                    }}>
                        {claim.corporateClaimNo ? claim.corporateClaimNo : "--"}
                    </a>
                        : (claim.corporateClaimNo ? claim.corporateClaimNo : "--")
                }
            </td>
            <td className="tbl-w-10 bg-transparent text-center" >{claim.financialYear ? claim.financialYear : "--"}</td>
            <td className="tbl-w-16 bg-transparent text-center">{claim.claimIntimationDate ? claim.claimIntimationDate : "--"}</td>
            <td className="tbl-w-17 bg-transparent">{claim.policyType ? claim.policyType : "--"}</td>
            <td className="tbl-w-17 bg-transparent">{claim.policyName ? claim.policyName : "--"}</td>
            <td className="tbl-w-16 bg-transparent">{claim.division ? claim.division : "--"}</td>
            <td className="tbl-w-28 bg-transparent">{claim.insurerName ? claim.insurerName : "--"}</td>
            <td className="tbl-w-28 bg-transparent">{claim.survayerName ? claim.survayerName : "--"}</td>
            <td className="tbl-w-16 bg-transparent text-center">{claim.shipmentValue ? claim.shipmentValue : "--"}</td>
            <td className="tbl-w-28 bg-transparent text-center"><span className="status" style={getClaimStatusColor(claim.claimStatus)}>{claim.claimStatus ? claim.claimStatus : "--"}</span></td>
            <td className="tbl-w-35 bg-transparent text-center"><span className="status" style={getCurrentStatusColor(claim.currentStatus)}>{claim.currentStatus ? claim.currentStatus : "--"}</span></td>
            <td className="tbl-w-10 bg-transparent text-center">{claim.tat ? claim.tat : "NA"}</td>
        </>
    )
}

const RaiseClaim = () => {
    const FY = generateFYList(2, 0);
    const FYList = FY.FYLeftYearList;
    const { currentFYLeftYear } = generateCurrentFY();
    const selectedFinancialYear = FYList.find(e => e.value == currentFYLeftYear)
    const [isLoading, setIsLoading] = useState(true)
    const [action, setAction] = useState({ type: null, raiseClaimId: null, claimDetails: null, policyTypeId: null })
    const [isAddEditModalOpen, setIsAddEditModalOpen] = useState(false)
    const [raiseClaimList, setRaiseClaimList] = useState([])
    const [activePage, setActivePage] = useState(1)
    const [totalItemsCount, setTotalItemsCount] = useState(0)
    const [policyTypeList, setPolicyTypeList] = useState([]);
    const [divisionDropdownList, setDivisionDropdownList] = useState([])
    const [policySubTypeList, setPolicySubTypeList] = useState([])
    const [claimStatusDropdownList, setClaimStatusDropdownList] = useState([])
    const [currentStatusDropdownList, setCurrentStatusDropdownList] = useState([])
    const [statusByUserDropdownList, setStatusByUserDropdownList] = useState([])

    const navigate = useNavigate();
    const location = useLocation();
    const { state: prevFilter } = location;

    const claimDaysArrayFilter = [
        {
            title: "All Days",
            purpose: "",
        },
        {
            title: "Less than 20 days",
            purpose: "0-19",
        }, {
            title: "20 - 30 days",
            purpose: "20-30",

        }, {
            title: "More than 30 days",
            purpose: "31-0",
        }
    ];

    const [filter, setFilter] = useState({
        searchText: "",
        finYear: selectedFinancialYear.label,
        policyTypeId: 0,
        policyNameId: 0,
        divisionId: getLoggedInUser()?.Role === "Divisional SPOC" ? Number(getLoggedInUser()?.DivisionId) : 0,
        claimStatusId: 0,
        claimStatusName: "",
        statusByUserId: 0,
        currentStatusId: 0,
        purpose: claimDaysArrayFilter[0]?.purpose,
        ...prevFilter
    })
    const [searchFilter, setSearchFilter] = useState(filter)
    const itemsCountPerPage = process.env.REACT_APP_ITEMS_PER_PAGE ? process.env.REACT_APP_ITEMS_PER_PAGE : 50

    const fetchPolicyTypeDropdownList = useCallback(async (year) => {
        const moduleResponse = await commonService.dropdown({ moduleName: 'policy-type', id: 0, purpose: `claim_${year}` });
        if (moduleResponse?.data?.isSuccess) {
            let policyTypes = moduleResponse.data.data
            policyTypes = policyTypes?.length > 0 ? policyTypes.map((module) => ({
                label: module.name,
                value: module.id,
            })) : [];
            setPolicyTypeList([{ label: "All Policy Types", value: 0 }, ...policyTypes])
        }
        return moduleResponse?.data?.isSuccess
    }, []);

    const fetchPolicySubType = useCallback(async (policyTypeId) => {
        const policyResponse = await commonService.dropdown({ moduleName: "policy-sub-type", id: filter?.policyTypeId || policyTypeId, purpose: `claim_${filter?.finYear}`, })
        if (policyResponse?.data?.isSuccess) {
            let subTypeList = policyResponse.data.data
            setPolicySubTypeList([{ name: "All Policy Names", id: 0 }, ...subTypeList])
        }
    }, [])

    const fetchStatus = useCallback(async (type, code) => {
        let payload = {}
        if (type === 3) {
            payload = { moduleName: "Status", id: 0, purpose: `status_${type}_${code}`, }
        } else {
            payload = { moduleName: "Status", id: 0, purpose: `status_${type}`, }
        }

        const statusResponse = await commonService.dropdown(payload)
        if (statusResponse?.data?.isSuccess) {
            let statusList = statusResponse.data.data
            if (type === 1) {
                let allClaimStatus = [{ name: "All Claim Status", id: 0 }, ...statusList]
                setClaimStatusDropdownList(allClaimStatus)
            }
            if (type === 2) {
                let allStatus = [{ name: "All User Status", id: 0 }, ...statusList]
                setStatusByUserDropdownList(allStatus)
            }
            if (type === 3) {
                setCurrentStatusDropdownList([{ name: "All Current Status", id: 0 }, ...statusList])
            }
        }
    }, [])
    const fetchDivisionDropdownList = useCallback(async (policyTypeId) => {
        const divisionResponse = await commonService.dropdown({ moduleName: "Division", id: 0, purpose: `claim_${policyTypeId}` })
        if (divisionResponse?.data?.isSuccess) {
            let divisionList = divisionResponse.data.data
            divisionList = divisionList?.length > 0 ? divisionList.map(division => ({ label: division.name, value: division.id, })) : []
            setDivisionDropdownList([{ label: "All Division", value: 0 }, ...divisionList])
        }
    }, [])

    const fetchRaiseClaimList = useCallback(async () => {
        setIsLoading(true)
        const claimResponse = await raiseClaimService.fetchAll({ ...searchFilter, pageNumber: activePage, pageSize: process.env.REACT_APP_ITEMS_PER_PAGE })
        if (claimResponse?.data?.isSuccess) {
            setRaiseClaimList(claimResponse.data.data)
            setTotalItemsCount(claimResponse?.data?.pagination?.totalSize)
        } else {
            setRaiseClaimList([])
            setTotalItemsCount(0)
        }
        setIsLoading(false)
    }, [activePage, searchFilter])


    const fetchClaimTemplateDetails = useCallback(async (raiseClaimId) => {
        const claimTemplateDetailsResponse = await raiseClaimService.raiseClaimDetails({ claimRaiseId: raiseClaimId });
        if (claimTemplateDetailsResponse?.isSuccess) {
            setAction({ ...action, policyTypeId: claimTemplateDetailsResponse.data?.policyTypeId, claimDetails: claimTemplateDetailsResponse.data })
            setIsAddEditModalOpen(true);
            return claimTemplateDetailsResponse.data
        }
    }, []);

    const handlePageChange = currentPage => {
        setActivePage(currentPage)
    }

    const selectSearch = async () => {
        setSearchFilter(filter)
        setActivePage(1);
    };

    const openAddEditModal = async action => {
        if (action?.raiseClaimId) {
            await fetchClaimTemplateDetails(action?.raiseClaimId);
        }
    }

    const handleCorporateNoClick = async (raiseClaimId) => {
        navigate('/external/raise-claim-summary',
            {
                state: {
                    FYList: FYList,
                    policyTypeList: policyTypeList,
                    policySubTypeList: policySubTypeList,
                    divisionDropdownList: divisionDropdownList,
                    raiseClaimId: raiseClaimId
                }
            });
    };

    const closeAddEditModal = () => {
        localStorage.removeItem('delayedIntimationReason');
        setIsAddEditModalOpen(false)
    }

    useEffect(() => {
        const fetchList = async () => {
            await fetchStatus(1)
            await fetchStatus(2)
            await fetchPolicyTypeDropdownList(selectedFinancialYear.label, "")
        }
        fetchList()
    }, [fetchPolicyTypeDropdownList])

    useEffect(() => {
        fetchRaiseClaimList()
    }, [fetchRaiseClaimList])

    return (
        <div>
            {!isLoading ? (
                <>
                    <div className="Body_topBar">
                        <div className="left">
                            <h5 className="fw-bold mb-0">Claim Management</h5>
                        </div>
                        <div className="right ">
                            <Export
                                label={"Claim MIS"}
                                filters={{
                                    PolicyNameId: filter?.policyNameId,
                                    claimStatusId: filter?.claimStatusId,
                                    claimStatusName: searchFilter?.claimStatusName,
                                    currentStatusId: filter?.currentStatusId,
                                    FinancialYear: filter?.finYear,
                                    PolicyTypeId: filter?.policyTypeId,
                                    DivisionId: filter?.divisionId,
                                }}
                                moduleName="RaiseClaim"
                                isDisabled={raiseClaimList?.length < 1}
                                fileName={`Claim-MIS-Report`}
                                ext="xlsx"
                            />
                        </div>
                    </div>

                    <div className="Body_topBar2nd_v2 Body_topBar2nd_wrpr_bdr">
                        <div className="d-flex left">
                            <div className="wrapper_boxs " style={{ position: 'relative' }}>
                                <Input className="p-0 border-0"
                                    placeholder="Search here"
                                    value={filter.searchText}
                                    onChange={e => setFilter({ ...filter, searchText: e.target.value })}
                                    onKeyDown={e => searchOnEnter(e, selectSearch)}
                                />
                                <div style={{ marginLeft: '5px', cursor: 'pointer' }} title="Corporate Claim No., Insurance Claim No., Surveyor Claim No., Shipment Number">
                                    <FaInfoCircle style={{ color: '#6c757d' }} />
                                </div>
                            </div>
                            <Select
                                options={FYList}
                                className="topBar_input"
                                getOptionValue={x => x.value}
                                getOptionLabel={x => x.label}
                                onChange={option => {
                                    if (option.label !== filter.finYear) {
                                        setFilter({ ...filter, finYear: option.label, policyTypeId: 0 })
                                        fetchPolicyTypeDropdownList(option.label, "onChange")
                                    }
                                }}
                                autoComplete="off"
                                value={FYList && FYList.length > 0 && FYList.find(fy => filter.finYear === fy.label)}
                                placeholder="Financial Year"
                            />

                            <Select
                                options={policyTypeList}
                                getOptionValue={x => x.value}
                                getOptionLabel={x => x.label}
                                onChange={option => {
                                    setFilter({ ...filter, policyTypeId: option.value, })
                                    getLoggedInUser().Role !== "Divisional SPOC" && fetchDivisionDropdownList(option?.value)
                                    fetchPolicySubType(option?.value)

                                }}
                                autoComplete="off"
                                value={policyTypeList && policyTypeList.length > 0 && policyTypeList.find(policyType => filter.policyTypeId === policyType.value)}
                                placeholder="Policy Type"
                            />
                            <Select
                                options={policySubTypeList}
                                getOptionValue={x => x.id}
                                getOptionLabel={x => x.name}
                                onChange={option => {
                                    setFilter({ ...filter, policyNameId: option.id, })
                                }}
                                value={policySubTypeList && policySubTypeList.length > 0 && policySubTypeList.find(policy => filter.policyNameId === policy.id)}
                                autoComplete="off"
                                placeholder="Policy Name"
                            />
                            <Select
                                options={divisionDropdownList}
                                className="topBar_input"
                                getOptionValue={x => x.value}
                                getOptionLabel={x => x.label}
                                isDisabled={getLoggedInUser().Role === "Divisional SPOC"}
                                onChange={option => {
                                    setFilter({ ...filter, divisionId: option.value, })
                                }}
                                autoComplete="off"

                                value={getLoggedInUser().Role === "Divisional SPOC" ? { label: getLoggedInUser().DivisionName, value: getLoggedInUser().DivisionId } : divisionDropdownList && divisionDropdownList.length > 0 && divisionDropdownList.find(division => filter.divisionId === division.value)}
                                placeholder="Division"
                            />
                            <Select
                                options={
                                    claimStatusDropdownList
                                    // .filter((claim) => claim.name !== "Drafted")
                                    // .map((claim) => ({
                                    //     ...claim,
                                    // }))
                                }
                                className="topBar_input"
                                getOptionValue={(x) => x.id}
                                getOptionLabel={(x) => x.name}
                                onChange={(option) => {
                                    setFilter({ ...filter, claimStatusId: option.id, claimStatusName: !option?.id ? "" : option.name });
                                }}
                                value={
                                    claimStatusDropdownList &&
                                    claimStatusDropdownList.length > 0 &&
                                    claimStatusDropdownList.find((claim) => filter.claimStatusId === claim.id)
                                }
                                autoComplete="off"
                                placeholder="Claim Status"
                            />
                            <Select
                                options={statusByUserDropdownList}
                                className="topBar_input"
                                getOptionValue={x => x.id}
                                getOptionLabel={x => x.name}
                                onChange={option => {
                                    if (option?.id) {
                                        fetchStatus(3, option?.code)
                                        setFilter({ ...filter, statusByUserId: option.id, currentStatusId: 0 })
                                    } else {
                                        setFilter({ ...filter, statusByUserId: 0, currentStatusId: 0 })
                                    }
                                }}
                                value={statusByUserDropdownList && statusByUserDropdownList.length > 0 && statusByUserDropdownList.find(userStatus => filter.statusByUserId === userStatus.id)}
                                autoComplete="off"
                            // placeholder="Status By User"
                            />

                            {filter?.statusByUserId ? <Select
                                options={currentStatusDropdownList}
                                className="topBar_input"
                                getOptionValue={x => x.id}
                                getOptionLabel={x => x.name}
                                onChange={option => {
                                    setFilter({ ...filter, currentStatusId: option.id })
                                }}
                                value={currentStatusDropdownList && currentStatusDropdownList.length > 0 && currentStatusDropdownList.find(currentStatus => filter.currentStatusId === currentStatus.id)}
                                autoComplete="off"
                                placeholder="Current Status"
                            /> : ''}
                            <Select
                                options={claimDaysArrayFilter}
                                className="topBar_input users_topbr_fld "
                                getOptionValue={x => x.purpose}
                                getOptionLabel={x => x.title}
                                onChange={option => {
                                    setFilter({ ...filter, purpose: option.purpose })
                                }}
                                value={claimDaysArrayFilter && claimDaysArrayFilter.length > 0 && claimDaysArrayFilter.find(days => filter.purpose === days.purpose)}
                                autoComplete="off"
                                placeholder="Days"
                            />
                            <InputGroupText className="searchButton idividualButton">
                                <Button
                                    color="link"
                                    className="p-0"
                                    disabled={isTwoObjectsEqual(searchFilter, filter)}
                                    onClick={selectSearch}
                                >
                                    <i className="bx bx-search"></i>
                                </Button>
                            </InputGroupText>
                            <Button
                                color="primary"
                                className="blueRefreshButton"
                                onClick={() => window.location.reload()}
                            >
                                <i className="bx bx-refresh"></i>
                            </Button>
                        </div>

                        <div className="right">
                            <div className="table_search_number">
                                Total <span>{totalItemsCount}</span>
                            </div>
                        </div>
                    </div>
                    {raiseClaimList?.length > 0 ? (
                        <>
                            <div className="table-responsive option_01">
                                <Table className="round_td">
                                    <thead>
                                        <tr>
                                            <th style={{ backgroundColor: '', padding: "4px" }}></th>
                                            <th className="text-center sl-n">Sl No.</th>
                                            <th className="tbl-w-3">Corporate Claim No.</th>
                                            <th className="tbl-w-10 text-center">Financial <br /> Year</th>
                                            <th className="tbl-w-16 text-center">Claim Intimation <br />Date</th>
                                            <th className="tbl-w-17">Policy Type</th>
                                            <th className="tbl-w-17">Policy Name</th>
                                            <th className="tbl-w-16">Division</th>
                                            <th className="tbl-w-28">Insurance Company</th>
                                            <th className="tbl-w-28">Surveyor Company</th>
                                            <th className="tbl-w-16 text-center">Shipment <br /> Number</th>
                                            <th className="tbl-w-28 text-center">Claim Status</th>
                                            <th className="tbl-w-35 text-center">Current Status</th>
                                            <th className="tbl-w-10 text-center">TAT <br />(In Days)</th>
                                            <th className="tbl-w-10">Edit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {raiseClaimList &&
                                            raiseClaimList.length > 0 &&
                                            raiseClaimList.map((claim, index) =>
                                                claim ? (
                                                    <tr key={claim.raiseClaimId} style={{ backgroundColor: claim?.isDraft ? "#F8E9DD" : "" }}>
                                                        <RaiseClaimList
                                                            index={
                                                                index + (activePage - 1) * itemsCountPerPage + 1
                                                            }
                                                            claim={claim}
                                                            handleCorporateNoClick={handleCorporateNoClick}
                                                        />
                                                        <td className="tbl-w-10 multiple_button text-center bg-transparent">
                                                            <Button
                                                                color="link"
                                                                className="p-0"
                                                                onClick={() => {
                                                                    openAddEditModal({
                                                                        ...action,
                                                                        type: "Edit",
                                                                        raiseClaimId: claim.raiseClaimId,
                                                                        policyTypeId: filter?.policyTypeId,
                                                                        claimDetails: null
                                                                    })
                                                                }}
                                                            >
                                                                <i
                                                                    className="bx bx-edit-alt"
                                                                    style={{ width: "24px" }}
                                                                ></i>
                                                            </Button>
                                                        </td>

                                                    </tr>
                                                ) : null
                                            )}
                                    </tbody>
                                </Table>
                            </div>

                            <div className="button_bottom_part">
                                <div className="left"></div>
                                <div className="right">
                                    <Pagination
                                        onChange={handlePageChange}
                                        current={activePage}
                                        total={totalItemsCount}
                                        pageSize={itemsCountPerPage}
                                    />
                                </div>
                            </div>
                        </>
                    ) : (
                        <p className="text-center no-data">No data found !</p>
                    )}
                </>
            ) : (
                <Loading />
            )}

            {isAddEditModalOpen ? (
                <RaiseClaimModal
                    fetchRaiseClaimList={fetchRaiseClaimList}
                    FYList={FYList}
                    policyTypeList={policyTypeList}
                    policySubTypeList={policySubTypeList}
                    action={{ ...action, type: 'Edit' }}
                    closeModal={closeAddEditModal}
                    isOpen={isAddEditModalOpen}
                />
            ) : null}
        </div>
    )
}

export default RaiseClaim
